module.exports = __webpack_public_path__ + "img/ozone.9fb3270b.svg";